<template>
  <v-app>
    <TheSnackbar />
    <v-navigation-drawer
      clipped
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>
        <v-list-tile :to="{ name: 'businesses' }" exact>
          <v-list-tile-action>
            <v-icon>list</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Geschäfte
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'sessions' }" exact>
          <v-list-tile-action>
            <v-icon>people</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Sessionen
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ name: 'protocols' }" exact>
          <v-list-tile-action>
            <v-icon>assignment</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Protokolle
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="$isSuperuser()" />
        <v-list-tile @click="notificationDialog = true" exact v-if="$isSuperuser()">
          <v-list-tile-action>
            <v-icon>send</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              Benachrichtigen
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      clipped-left
      color="white"
      light
      app
      fixed
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <!-- Fixed width to make the search field align the same as the drawer -->
      <v-toolbar-title style="width: 231px" class="ml-2">
        <img src="../../assets/logo.jpg" width="200" />
      </v-toolbar-title>
      <v-text-field
        flat
        solo-inverted
        prepend-inner-icon="search"
        label="Suche"
        class="hidden-sm-and-down"
        style="display: none;"
      ></v-text-field>
      <v-spacer></v-spacer>
      <span v-if="$isLoggedIn()">Eingeloggt als <b>{{ username }}</b></span>
      <v-menu bottom offset-y v-if="$isLoggedIn()">
        <v-btn slot="activator" class="settings" icon flat large>
          <v-icon>settings</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="passwordDialog = !passwordDialog">
            Passwort ändern
          </v-list-tile>
          <v-list-tile @click="logout">
            Abmelden
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn
        v-else
        :to="{ name: 'login', query: { to: $route.fullPath } }"
        depressed
      >
        anmelden
      </v-btn>
    </v-toolbar>
    <v-content>
      <ChangePasswordDialog v-model="passwordDialog" v-if="$isLoggedIn()" />
      <SendNotificationDialog v-model="notificationDialog" v-if="$isSuperuser()" />
      <slot/>
    </v-content>
  </v-app>
</template>

<script>
import { revokeToken, getUsername } from '@/helpers/authentication';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'BaseLayout',
  data: () => ({
    drawer: null,
    passwordDialog: false,
  }),
  computed: {
    username() {
      return getUsername();
    },
    notificationDialog: {
      get() { return this.getShow; },
      set(value) { this.setShow({ show: value }); },
    },
    ...mapGetters({
      getShow: 'notificationDialog/getShow',
    }),
  },
  methods: {
    logout() {
      revokeToken();
      // Reload the app to have a clean state.
      window.location = '/';
    },
    ...mapActions({
      setShow: 'notificationDialog/setShow',
    }),
  },
};
</script>
